import { useEffect, useCallback } from 'react';
import { qualify } from 'app/lib/infermedica';
import { DiagnoseResponse } from 'app/types/Infermedica';
import { TriageBlockConfig } from '../TriageBlock';

export const code: TriageBlockConfig['code'] = 'evaluate';

export const codePostfix: TriageBlockConfig['codePostfix'] = true;

export const Message: TriageBlockConfig['Message'] = ({ dataValue, setCurrentDataValue, replaceBlock, sessionId }) => {
  const runEvaluation = useCallback(
    async ({ prompt: { conditions = [] } = {} as DiagnoseResponse }: { prompt: DiagnoseResponse }) => {
      const { service, matchingCondition } = await qualify({
        sessionId,
        conditions,
        state: sessionStorage.getItem('stateSelection')!,
      });

      const data = {
        ...dataValue,
        isTreatable: !!service,
        condition: matchingCondition,
        service,
      };

      setCurrentDataValue(data);

      if (!service) {
        replaceBlock('disqualify', data);
      } else {
        replaceBlock('protocolizedVisit', data);
      }
    },
    [dataValue, replaceBlock, sessionId, setCurrentDataValue]
  );

  useEffect(() => {
    runEvaluation(dataValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export const Response = () => null;

export const SavedResponse = () => null;
